import React, { useEffect, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

export default function Pagination({ showPrePage, onPaginationChange, total }) {
  const [counter, setCounter] = useState(1);
  const [numberOfButton, setNumberOfButton] = useState(0);

  // Reset page when total changes
  useEffect(() => {
    setCounter(1);
  }, [total]);

  // Update button count and notify parent of new range
  useEffect(() => {
    if (showPrePage > 0 && total >= 0) {
      const value = showPrePage * counter;
      onPaginationChange(value - showPrePage, value);
      setNumberOfButton(Math.ceil(total / showPrePage));
    }
  }, [counter, total, showPrePage]);

  // Navigation logic
  const onButtonClick = (type) => {
    if (type === "p" && counter > 1) {
      setCounter(counter - 1);
    } else if (type === "n" && counter < numberOfButton) {
      setCounter(counter + 1);
    }
  };

  return (
    <>
      <div className="mt-4 d-flex justify-content-end mr-4">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            {/* First page */}
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => setCounter(1)}
                style={{ color: "#66a725", cursor: "pointer" }}
              >
                <KeyboardDoubleArrowLeftIcon style={{ fontSize: "15px" }} />
              </a>
            </li>

            {/* Previous page */}
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => onButtonClick("p")}
                style={{ color: "#66a725", cursor: "pointer" }}
              >
                <KeyboardArrowLeftIcon style={{ fontSize: "15px" }} />
              </a>
            </li>

            {/* Page number buttons */}
            {numberOfButton > 0 &&
              new Array(numberOfButton).fill("").map((_, index) => {
                const page = index + 1;
                const isActive = page === counter;
                const isVisible =
                  page === counter ||
                  page === counter - 1 ||
                  page === counter + 1;

                return (
                  isVisible && (
                    <li
                      key={index}
                      className={`page-item ${isActive ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCounter(page)}
                        style={{
                          backgroundColor: isActive ? "#66a725" : "white",
                          color: isActive ? "white" : "#66a725",
                        }}
                      >
                        {page}
                      </button>
                    </li>
                  )
                );
              })}

            {/* Next page */}
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => onButtonClick("n")}
                style={{ color: "#66a725", cursor: "pointer" }}
              >
                <KeyboardArrowRightIcon style={{ fontSize: "15px" }} />
              </a>
            </li>

            {/* Last page */}
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => setCounter(numberOfButton)}
                style={{ color: "#66a725", cursor: "pointer" }}
              >
                <KeyboardDoubleArrowRightIcon style={{ fontSize: "15px" }} />
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <style jsx>{`
        .page-item.active .page-link {
          border-color: #66a725;
        }
      `}</style>
    </>
  );
}
